/**
 * The block mutation's key: what the feed's "Blocked @name." line watches.
 *
 * In a file of its own, and a small one. The toast that says whom the tab
 * just blocked is mounted at the root — it has to be, since a block can be
 * made on a person's page and read on the feed — and it imported the key
 * from the moderation queries, which import the dashboard's, the feed's
 * and the friends'. Every page paid for that: the front door and a shared
 * film read by a stranger downloaded the diary's whole query module, forty
 * kilobytes, for one two-character string. Measured at 595kB on the door
 * where it had been 531 a day before.
 */
export const BLOCK_MUTATION_KEY = ["block"] as const;
